import React, { useEffect, useMemo, useState } from "react";
import "./EcomAllEmployees.css";
import DashBoardHead from "../DashBoard/DashBoardHead";
import api from "../../Components/Registration/Api";

function EcomAllUsers() {
  const [statusFilter, setStatusFilter] = useState("UNREVIEWED");
  const [users, setUsers] = useState([]);
  const [segments, setSegments] = useState([]);
  const [selectedSegments, setSelectedSegments] = useState({});
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  const loadUsers = async () => {
    setLoading(true);
    setError("");
    try {
      const res = await api.get(`/api/customer-approvals?status=${statusFilter}`);
      setUsers(res.data.results || []);
      setSegments(res.data.segments || []);
      const defaults = {};
      (res.data.results || []).forEach((u) => {
        defaults[u.id] = u.approved_customer_type || u.registered_customer_type || "END_USER";
      });
      setSelectedSegments(defaults);
    } catch (err) {
      setError(err.response?.data?.detail || "Unable to load customer approvals.");
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    loadUsers();
  }, [statusFilter]);

  const segmentLabel = useMemo(() => Object.fromEntries(segments.map((s) => [s.value, s.label])), [segments]);

  const handleDecision = async (user, action) => {
    const approvedType = selectedSegments[user.id];
    if (action === "APPROVE" && !approvedType) {
      alert("Please select an approved customer segment.");
      return;
    }
    const reviewNotes = window.prompt(action === "APPROVE" ? "Approval notes (optional)" : "Reason for rejection (recommended)", "") ?? "";
    try {
      await api.patch(`/api/customer-approvals/${user.id}`, {
        action,
        approved_customer_type: approvedType,
        review_notes: reviewNotes,
      });
      await loadUsers();
    } catch (err) {
      alert(err.response?.data?.detail || "Unable to update approval.");
    }
  };

  const DocumentLink = ({ url, label }) => url ? (
    <a href={url} target="_blank" rel="noopener noreferrer">{label}</a>
  ) : <span className="kyc-missing">Not uploaded</span>;

  return (
    <div className="ecom-allusers-container">
      <DashBoardHead />
      <div className="ecom-allusers-headers">
        <div className="ecom-allusers-left-person-heading">
          {[
            ["UNREVIEWED", "Pending Approval"],
            ["APPROVED", "Approved"],
            ["REJECTED", "Rejected"],
          ].map(([value, label]) => (
            <p key={value} onClick={() => setStatusFilter(value)} className={statusFilter === value ? "ecom-user-active" : ""}>{label}</p>
          ))}
        </div>
      </div>

      {error && <p style={{ color: "red", marginTop: "1rem" }}>{error}</p>}
      {loading ? <p style={{ marginTop: "2rem" }}>Loading approval requests...</p> : (
        <div className="ecom-allusers-left-details table-container">
          <table className="user-table">
            <thead><tr><th>Name</th><th>Phone</th><th>Registered Segment</th><th>Business</th><th>KYC</th><th>Approved Segment</th><th>Status / Action</th></tr></thead>
            <tbody>
              {users.map((user) => (
                <tr key={user.id}>
                  <td data-label="Name"><b>{user.name || user.username}</b><br /><small>{user.email}</small></td>
                  <td data-label="Phone">+91 {user.mobile_number}</td>
                  <td data-label="Registered Segment">{segmentLabel[user.registered_customer_type] || user.registered_customer_type}</td>
                  <td data-label="Business">{user.company_name || "-"}<br /><small>{user.gst_number ? `GST: ${user.gst_number}` : "No GST"}</small></td>
                  <td data-label="KYC" className="kyc-links"><DocumentLink url={user.aadhaar_document_url} label="Masked Aadhaar" /><DocumentLink url={user.pan_document_url} label="PAN" /><DocumentLink url={user.gst_document_url} label="GST" /><DocumentLink url={user.bank_document_url} label="Bank" /></td>
                  <td data-label="Approved Segment">
                    <select value={selectedSegments[user.id] || ""} onChange={(e) => setSelectedSegments((prev) => ({ ...prev, [user.id]: e.target.value }))} disabled={statusFilter !== "UNREVIEWED"}>
                      {segments.map((segment) => <option key={segment.value} value={segment.value}>{segment.label}</option>)}
                    </select>
                  </td>
                  <td data-label="Status / Action">
                    {statusFilter === "UNREVIEWED" ? <div className="approval-actions"><button className="ecom-alluser-approve" onClick={() => handleDecision(user, "APPROVE")}>Approve</button><button className="ecom-user-reject" onClick={() => handleDecision(user, "REJECT")}>Reject</button></div> : <span>{user.commercial_status}</span>}
                  </td>
                </tr>
              ))}
              {users.length === 0 && <tr><td colSpan="7">No {statusFilter.toLowerCase()} customer requests.</td></tr>}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

export default EcomAllUsers;
